import { endProcess, startProcess } from "modules/app/appSlice";
import { call, put, takeLatest } from "redux-saga/effects";

import { updateMemberInfo } from "./memberActions";
import memberServices from "./memberServices";

function* updateMemberInfoSaga(action: ReturnType<typeof updateMemberInfo>) {
  const { params, onSuccess, onFailure } = action.payload;

  // try {
  //   yield put(startProcess());
  //   const memberData = yield call(memberServices.updateMember, { ...params });

  //   onSuccess?.(memberData);
  // } catch (error: any) {
  //   console.log("activelinxx debug", "updateMemberInfoSaga failed", error);
  //   onFailure?.(error);
  // } finally {
  //   yield put(endProcess());
  // }
}

export default function* () {
  yield takeLatest(updateMemberInfo, updateMemberInfoSaga);
}
